import config from '@/config'; // eslint-disable-line import/extensions

export default {
  namespaced: true,
  state: {
    isSnowing: config.isSnowing,
  },
  mutations: {
    setSnowing(state, isSnowing) {
      state.isSnowing = isSnowing;
    },
  },
};
